import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "titlePages text-truncate" }
const _hoisted_2 = { class: "text-grey-lighten-1" }

import { ref, computed, onMounted, onUnmounted } from 'vue';
import { useI18n } from 'vue-i18n';
// import { useStore } from 'vuex';

import LatencyGrid from '@/components/SmartLink/topology/LatencyGrid.vue';
import CircularTopology from '@/components/SmartLink/topology/CircularTopology.vue';
import MeshTopology from '@/components/SmartLink/topology/MeshTopology.vue';
import DialogComponent from '@/components/SmartLink/dialog/dialogComponent.vue';
import Prog_circular from '@/components/PrincipalComponents/Prog_circular.vue';

// import { LABELS } from '@/constants/labels';
import { getAllLatencyData } from '@/services/Smartlink/KPI';
import { getOperabilityLastDayTopology } from '@/services/Smartlink/Topology';
import { LATENCY } from '@/interfaces/SmartLink/Topology';
import { OPERABILITY } from '@/interfaces/SmartLink/Equipos';
import { getDeviceModel, extractNumberFromName } from '@/utils/SmartLink/device';
import { getRajantGPS } from "@/services/Smartlink/Drive";
import { getAllDataLatLngSM } from "@/services/Smartlink/Map";


export default /*@__PURE__*/_defineComponent({
  __name: 'AllLatencyView',
  setup(__props) {

const { t } = useI18n();
// const store = useStore();

const activeTab = ref('grid');
// Inicializamos como un arreglo para permitir la selección múltiple
const selectedSubtype = ref<string[]>(['distribución']);
const rawData = ref<LATENCY[]>([]);
const getAllIEOByIP = ref<OPERABILITY[]>([]);
const searchQuery = ref('');
const showError = ref(false);
const showCircle = ref(true);
const loadingRefresh = ref(false);
const sortBy = ref('latency_desc');

const dialog = ref(false);
const selectedIp = ref('');
const selectedName = ref('');
const selectedType = ref('');
const selectedModel = ref('');

const sortOptions = [
    { title: 'Mayor Latencia', value: 'latency_desc' },
    { title: 'Menor Latencia', value: 'latency_asc' },
    { title: 'Nombre (A - Z)', value: 'name_asc' },
    { title: 'IP', value: 'ip_asc' }
];

let timerId: ReturnType<typeof setInterval> | null = null;

const currentViewTitle = computed(() => {
    if (activeTab.value === 'grid') return t('title.allLatency') || 'Monitor de Latencias';
    if (activeTab.value === 'topology') return 'Topología por Zonas de Latencia';
    return 'Vista de Mapa';
});

function getLatencyColor(latencia: number): string {
    if (latencia < 0) return '#9E9E9E';   
    if (latencia <= 100) return '#00E676'; 
    if (latencia <= 500) return '#FFEA00'; 
    return '#FF3D00';                      
}

function getOperabilityPercentages(ip: string) {
    const item = getAllIEOByIP.value.find(op => op.ip === ip);
    if (!item) return { ok: 0, alert: 0, alarm: 0, down: 100 };
    const total = (item.ok || 0) + (item.alert || 0) + (item.alarm || 0) + (item.down || 0);
    if (total === 0) return { ok: 0, alert: 0, alarm: 0, down: 100 };
    return { ok: ((item.ok || 0) / total) * 100, alert: ((item.alert || 0) / total) * 100, alarm: ((item.alarm || 0) / total) * 100, down: ((item.down || 0) / total) * 100 };
}

async function getAllLatencies(isManualRefresh = false) {
    if (isManualRefresh) loadingRefresh.value = true;

    // 1. Cargar Operatividad
    const opRes = await getOperabilityLastDayTopology();
    if (opRes.status === 200) getAllIEOByIP.value = opRes.data;

    // 2. Cargar Latencias, GPS Rajant y GPS SM en paralelo
    const [responseLat, responseGps, responseSm] = await Promise.all([
        getAllLatencyData(),
        getRajantGPS(),
        getAllDataLatLngSM()
    ]);

    showError.value = !responseLat.showGraphs;
    showCircle.value = false;
    loadingRefresh.value = false;

    if (responseLat.status === 200) {
        const latencyData = responseLat.data || [];
        const gpsRajantData = responseGps.status === 200 ? responseGps.data : [];
        const smData = responseSm.status === 200 ? responseSm.data : [];

        // Mapa de coordenadas por IP directa de Rajant
        const rajantGpsMap = new Map<string, { latitud: number; longitud: number }>();
        
        // MAPA EXCLUSIVO DE ACCESO AP MÓVIL POR IDENTIFICADOR NUMÉRICO
        const apMovilGpsMapById = new Map<string, { latitud: number; longitud: number }>();

        gpsRajantData.forEach((g: any) => {
            if (g.ip && g.latitud && g.longitud) {
                rajantGpsMap.set(g.ip, { latitud: g.latitud, longitud: g.longitud });

                // DISCRIMINACIÓN ESTRICТА: Solo Acceso AP Móvil
                const isAcceso = g.subtipo?.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "") === "acceso";
                const isApMovil = g.tipo?.toLowerCase().replace(/\s+/g, "") === "apmovil";

                if (isAcceso && isApMovil) {
                    const idNum = extractNumberFromName(g.name, "RAJANT");
                    if (idNum) {
                        apMovilGpsMapById.set(idNum, { latitud: g.latitud, longitud: g.longitud });
                    }
                }
            }
        });

        // Mapa de datos SM por IP
        const smGpsMap = new Map<string, any>();
        smData.forEach((s: any) => {
            if (s.ip) smGpsMap.set(s.ip, s);
        });

        const extractGpsIp = (anotacion: any): string => {
            if (!anotacion) return '';
            try {
                const parsed = typeof anotacion === 'string' ? JSON.parse(anotacion) : anotacion;
                return parsed?.gps || '';
            } catch {
                const match = String(anotacion).match(/gps:\s*["']?([^"',}]+)["']?/);
                return match ? match[1].trim() : '';
            }
        };

        // 3. Fusionar datos de Latencia con Coordenadas
        rawData.value = latencyData.map((item: LATENCY) => {
            let latitud = 0;
            let longitud = 0;

            const isSubtipoDistribucion = item.subtipo?.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "") === 'distribución';
            const smInfo = smGpsMap.get(item.ip);

            // Si es PMP-SM / Distribución
            if (isSubtipoDistribucion || smInfo) {
                // Opción A: Probar con la IP especificada dentro de anotación.gps
                const targetGpsIp = extractGpsIp(item.anotacion) || extractGpsIp(smInfo?.anotacion);

                if (targetGpsIp && rajantGpsMap.has(targetGpsIp)) {
                    const linkedGps = rajantGpsMap.get(targetGpsIp)!;
                    latitud = linkedGps.latitud;
                    longitud = linkedGps.longitud;
                } else {
                    // Opción B: Si no vino la IP en la anotación, asociar por identificador con un ACCESO AP MÓVIL
                    const smIdNum = extractNumberFromName(item.name, "PMPSM");
                    if (smIdNum && apMovilGpsMapById.has(smIdNum)) {
                        const linkedGps = apMovilGpsMapById.get(smIdNum)!;
                        latitud = linkedGps.latitud;
                        longitud = linkedGps.longitud;
                    }
                }
            } else {
                // Para Acceso / Clientes con GPS directo
                const rajantGps = rajantGpsMap.get(item.ip);
                if (rajantGps) {
                    latitud = rajantGps.latitud;
                    longitud = rajantGps.longitud;
                }
            }

            const gpsInfo = gpsRajantData.find((g: any) => g.ip === item.ip);

            return {
                ...item,
                latitud,
                longitud,
                tipo: item.tipo || gpsInfo?.tipo || smInfo?.tipo || '',
                subtipo: item.subtipo || gpsInfo?.subtipo || ''
            };
        });
    }
}

function showDialogWithType(item: LATENCY) {
    selectedIp.value = item.ip;
    selectedName.value = item.name;
    selectedType.value = item.tipo;
    selectedModel.value = getDeviceModel(item.anotacion);
    dialog.value = true;
}

function formatShortDate(dateStr?: string) {
    if (!dateStr) return 'N/A';
    const parts = dateStr.trim().split(' ');
    return parts.length < 2 ? dateStr : `${parts[0]} ${parts[1].substring(0, 5)}`;
}

// NUEVA FUNCIÓN PARA BÚSQUEDA MÚLTIPLE CON COMODINES
function matchesSearch(item: LATENCY, queryStr: string): boolean {
    if (!queryStr) return true;
    
    // Separamos por comas, limpiamos espacios y pasamos a minúsculas
    const terms = queryStr.split(',').map(t => t.trim().toLowerCase()).filter(t => t.length > 0);
    if (terms.length === 0) return true;

    // Evaluamos si el item coincide con AL MENOS UNO de los términos ingresados
    return terms.some(term => {
        // Escapamos caracteres especiales de regex excepto el asterisco (*)
        const escapedTerm = term.replace(/[.+?^${}()|[\]\\]/g, '\\$&');
        // Convertimos el asterisco en el comodín universal de RegExp ".*"
        const regexStr = escapedTerm.replace(/\*/g, '.*');
        
        try {
            const regex = new RegExp(regexStr, 'i'); // 'i' para ignorar mayúsculas/minúsculas
            return (
                regex.test(item.name || '') ||
                regex.test(item.ip || '') ||
                regex.test(item.tipo || '')
            );
        } catch (e) {
            // Fallback por seguridad en caso de error con la expresión regular
            const cleanTerm = term.replace(/\*/g, '');
            return (
                item.name?.toLowerCase().includes(cleanTerm) ||
                item.ip?.toLowerCase().includes(cleanTerm) ||
                item.tipo?.toLowerCase().includes(cleanTerm)
            );
        }
    });
}

const filteredDataBySubtype = computed(() => {
    const query = (searchQuery.value || '').trim();

    return rawData.value.filter(item => {
        if (!item.subtipo) return false;

        const normalizedSubtype = item.subtipo.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        
        // Normalizamos todos los subtipos actualmente seleccionados en el arreglo
        const targetSubtypes = selectedSubtype.value.map((val: string) => 
            val.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")
        );
        
        // Comprobamos si el elemento coincide con AL MENOS UNO de los subtipos seleccionados
        const matchesSubtype = targetSubtypes.length === 0 || targetSubtypes.includes(normalizedSubtype);

        if (!query) return matchesSubtype;

        // Utilizamos la nueva función de búsqueda
        const matchesQuery = matchesSearch(item, query);

        return matchesSubtype && matchesQuery;
    });
});

const filteredGroups = computed(() => {
    const query = (searchQuery.value || '').trim();

    // 1. Filtrar por búsqueda usando la nueva función múltiple
    const filtered = rawData.value.filter((item: LATENCY) => {
        if (!query) return true;
        return matchesSearch(item, query);
    });

    // 2. Ordenar arreglo según la opción elegida en sortBy
    filtered.sort((a, b) => {
        if (sortBy.value === 'latency_desc') {
            const latA = a.latencia < 0 ? 999999 : a.latencia;
            const latB = b.latencia < 0 ? 999999 : b.latencia;
            return latB - latA;
        } 
        if (sortBy.value === 'latency_asc') {
            const latA = a.latencia < 0 ? 999999 : a.latencia;
            const latB = b.latencia < 0 ? 999999 : b.latencia;
            return latA - latB;
        }
        if (sortBy.value === 'name_asc') {
            return (a.name || '').localeCompare(b.name || '');
        }
        if (sortBy.value === 'ip_asc') {
            return (a.ip || '').localeCompare(b.ip || '');
        }
        return 0;
    });

    // 3. Agrupar por subtipos
    const categories = [
        { key: 'distribución', title: 'Distribución' },
        { key: 'acceso', title: 'Acceso' },
        { key: 'cliente', title: 'Clientes' }
    ];

    return categories.map(cat => ({
        subtipo: cat.key,
        title: cat.title,
        items: filtered.filter((item: LATENCY) => {
            if (!item.subtipo) return false;
            return item.subtipo.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "") ===
                   cat.key.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        })
    }));
});

function countBySubtype(subtypeKey: string): number {
    if (!rawData.value || rawData.value.length === 0) return 0;

    // Normalizar la clave buscada (eliminar tildes, minúsculas y espacios)
    const targetKey = subtypeKey
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .trim();

    return rawData.value.filter(item => {
        if (!item.subtipo) return false;

        // Normalizar el subtipo proveniente del objeto
        const itemSubtype = item.subtipo
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .trim();

        // Comparación flexible (soporta singular/plural y coincidencia exacta)
        return (
            itemSubtype === targetKey ||
            itemSubtype.startsWith(targetKey) ||
            targetKey.startsWith(itemSubtype)
        );
    }).length;
}

onMounted(() => {
    getAllLatencies();
    timerId = setInterval(() => getAllLatencies(), 60000);
});
onUnmounted(() => timerId && clearInterval(timerId));

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_btn_toggle = _resolveComponent("v-btn-toggle")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    class: "defaultCard pa-3",
    color: "bgtopology",
    flat: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_tabs, {
        modelValue: activeTab.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeTab).value = $event)),
        color: "primary",
        class: "mb-3",
        "align-tabs": "start",
        "show-arrows": ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_tab, { value: "grid" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, {
                start: "",
                size: "small"
              }, {
                default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                  _createTextVNode("mdi-grid", -1)
                ]))]),
                _: 1
              }),
              _cache[9] || (_cache[9] = _createTextVNode(" Tarjeta de Latencias ", -1))
            ]),
            _: 1
          }),
          _createVNode(_component_v_tab, { value: "topology" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, {
                start: "",
                size: "small"
              }, {
                default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                  _createTextVNode("mdi-hub", -1)
                ]))]),
                _: 1
              }),
              _cache[11] || (_cache[11] = _createTextVNode(" Topología por Zonas ", -1))
            ]),
            _: 1
          }),
          _createVNode(_component_v_tab, { value: "mesh" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, {
                start: "",
                size: "small"
              }, {
                default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                  _createTextVNode("mdi-sitemap", -1)
                ]))]),
                _: 1
              }),
              _cache[13] || (_cache[13] = _createTextVNode(" Vista de Mapa ", -1))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_row, { class: "ma-0 align-center justify-space-between mb-3 ga-2" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            sm: "auto",
            class: "pa-0 d-flex align-center ga-2"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_1, _toDisplayString(currentViewTitle.value), 1),
              _createVNode(_component_v_btn, {
                icon: "mdi-refresh",
                variant: "tonal",
                color: "primary",
                size: "x-small",
                loading: loadingRefresh.value,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (getAllLatencies(true)))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    size: "16",
                    class: _normalizeClass({ 'spin-icon': loadingRefresh.value })
                  }, {
                    default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                      _createTextVNode("mdi-refresh", -1)
                    ]))]),
                    _: 1
                  }, 8, ["class"]),
                  _createVNode(_component_v_tooltip, {
                    activator: "parent",
                    location: "bottom"
                  }, {
                    default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                      _createTextVNode("Actualizar datos", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["loading"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            sm: "auto",
            class: "pa-0 d-flex flex-wrap align-center justify-end ga-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field, {
                modelValue: searchQuery.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchQuery).value = $event)),
                density: "compact",
                variant: "outlined",
                "hide-details": "",
                placeholder: "Ej: ES*, LX5*, 192.168...",
                "prepend-inner-icon": "mdi-magnify",
                clearable: "",
                class: "flex-grow-1 flex-sm-grow-0",
                style: {"min-width":"240px","max-width":"100%"}
              }, null, 8, ["modelValue"]),
              (activeTab.value === 'grid')
                ? (_openBlock(), _createBlock(_component_v_select, {
                    key: 0,
                    modelValue: sortBy.value,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((sortBy).value = $event)),
                    items: sortOptions,
                    "item-title": "title",
                    "item-value": "value",
                    density: "compact",
                    variant: "outlined",
                    "hide-details": "",
                    class: "flex-grow-1 flex-sm-grow-0",
                    style: {"min-width":"180px","max-width":"100%"},
                    "prepend-inner-icon": "mdi-sort"
                  }, null, 8, ["modelValue"]))
                : (_openBlock(), _createBlock(_component_v_btn_toggle, {
                    key: 1,
                    modelValue: selectedSubtype.value,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((selectedSubtype).value = $event)),
                    color: "primary",
                    multiple: "",
                    density: "compact",
                    variant: "outlined",
                    class: "flex-grow-1 flex-sm-grow-0 custom-responsive-toggle"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        value: "distribución",
                        class: "flex-grow-1"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            start: "",
                            size: "small",
                            class: "hidden-xs-only"
                          }, {
                            default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                              _createTextVNode("mdi-routes", -1)
                            ]))]),
                            _: 1
                          }),
                          _cache[17] || (_cache[17] = _createElementVNode("span", null, "Distribución", -1)),
                          _createVNode(_component_v_chip, {
                            size: "x-small",
                            color: "primary",
                            class: "ml-1 px-1",
                            style: {"height":"14px"}
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(countBySubtype('distribución')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_btn, {
                        value: "acceso",
                        class: "flex-grow-1"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            start: "",
                            size: "small",
                            class: "hidden-xs-only"
                          }, {
                            default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                              _createTextVNode("mdi-access-point", -1)
                            ]))]),
                            _: 1
                          }),
                          _cache[19] || (_cache[19] = _createElementVNode("span", null, "Acceso", -1)),
                          _createVNode(_component_v_chip, {
                            size: "x-small",
                            color: "primary",
                            class: "ml-1 px-1",
                            style: {"height":"14px"}
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(countBySubtype('acceso')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_btn, {
                        value: "cliente",
                        class: "flex-grow-1"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            start: "",
                            size: "small",
                            class: "hidden-xs-only"
                          }, {
                            default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                              _createTextVNode("mdi-account-network", -1)
                            ]))]),
                            _: 1
                          }),
                          _cache[21] || (_cache[21] = _createElementVNode("span", null, "Clientes", -1)),
                          _createVNode(_component_v_chip, {
                            size: "x-small",
                            color: "primary",
                            class: "ml-1 px-1",
                            style: {"height":"14px"}
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(countBySubtype('cliente')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"]))
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_window, {
        modelValue: activeTab.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((activeTab).value = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_window_item, { value: "grid" }, {
            default: _withCtx(() => [
              (showCircle.value)
                ? (_openBlock(), _createBlock(_component_v_sheet, {
                    key: 0,
                    class: "text-center py-8",
                    color: "transparent"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(Prog_circular)
                    ]),
                    _: 1
                  }))
                : (showError.value)
                  ? (_openBlock(), _createBlock(_component_v_row, {
                      key: 1,
                      class: "ma-0 py-4 justify-center"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("h3", _hoisted_2, _toDisplayString(_unref(t)('noInformation')), 1)
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(LatencyGrid, {
                      key: 2,
                      "filtered-groups": filteredGroups.value,
                      "get-latency-color": getLatencyColor,
                      "get-operability-percentages": getOperabilityPercentages,
                      "format-short-date": formatShortDate,
                      onSelectDevice: showDialogWithType
                    }, null, 8, ["filtered-groups"]))
            ]),
            _: 1
          }),
          _createVNode(_component_v_window_item, { value: "topology" }, {
            default: _withCtx(() => [
              _createVNode(CircularTopology, {
                items: filteredDataBySubtype.value,
                "get-operability-percentages": getOperabilityPercentages,
                "format-short-date": formatShortDate,
                onSelectDevice: showDialogWithType
              }, null, 8, ["items"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_window_item, { value: "mesh" }, {
            default: _withCtx(() => [
              _createVNode(MeshTopology, {
                items: filteredDataBySubtype.value,
                "get-latency-color": getLatencyColor,
                "get-operability-percentages": getOperabilityPercentages,
                "format-short-date": formatShortDate,
                onSelectDevice: showDialogWithType
              }, null, 8, ["items"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_dialog, {
        modelValue: dialog.value,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((dialog).value = $event)),
        width: "85%"
      }, {
        default: _withCtx(() => [
          (dialog.value)
            ? (_openBlock(), _createBlock(DialogComponent, {
                key: 0,
                ip: selectedIp.value,
                typeSel: selectedType.value,
                name: selectedName.value,
                model: selectedModel.value,
                onDialog: _cache[6] || (_cache[6] = ($event: any) => (dialog.value = false))
              }, null, 8, ["ip", "typeSel", "name", "model"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}
}

})